import React, { useEffect } from 'react';
import { trackEvent } from '../../utils/matomoEvents';

export default function Bio() {
  // Track Bio section view on mount
  useEffect(() => {
    trackEvent('Home', 'ViewSection', 'About Us Bio');
  }, []);

  return (
    <section className="bio-section">
      <div className="bio-content">
        <h2>About Us</h2>
        <p>
          Welcome to Gator Skin Frenchies, where passion meets excellence in French Bulldog breeding.
          We specialize in raising healthy, well-tempered French
          Bulldogs with distinctive qualities and loving personalities.
        </p>
        <p>
          Our commitment to ethical breeding practices and exceptional care ensures that each puppy
          from our program is raised in a loving, nurturing environment. We take pride in producing
          French Bulldogs that become cherished family members.
        </p>
      </div>

      <style jsx>{`
        .bio-section {
          padding: 4rem 2rem;
          background-color: var(--surface-alt);
        }

        .bio-content {
          max-width: 800px;
          margin: 0 auto;
          text-align: center;
        }

        h2 {
          font-size: 2.5rem;
          color: var(--text);
          margin-bottom: 2rem;
        }

        p {
          font-size: 1.1rem;
          line-height: 1.8;
          color: var(--text-muted);
          margin-bottom: 1.5rem;
        }

        @media (max-width: 768px) {
          .bio-section {
            padding: 3rem 1.5rem;
          }

          h2 {
            font-size: 2rem;
          }

          p {
            font-size: 1rem;
          }
        }
      `}</style>
    </section>
  );
}